"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveFundraiserFormTitle = void 0;
const email_templates_1 = require("../../internationalization/locales/email-templates");
const resolveFundraiserFormTitle = ({ title, isIndividualFundraiser, locale, }) => {
    if (!isIndividualFundraiser) {
        return title;
    }
    return (0, email_templates_1.getEmailLabels)(locale).fundraiserIndividualFormTitle.replace("{name}", title);
};
exports.resolveFundraiserFormTitle = resolveFundraiserFormTitle;
